module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-f89ea4967cab22ac1a861ef5d42270fa.png";